import { Navigate, Route, Routes } from 'react-router-dom';

import { Layout } from './app/Layout.tsx';
import { Login } from './features/auth/Login.tsx';
import { RotaProtegida } from './features/auth/RotaProtegida.tsx';
import { Clientes } from './features/clientes/Clientes.tsx';
import { Contabilidades } from './features/contabilidades/Contabilidades.tsx';
import { ArquivosFiscais } from './features/arquivos-fiscais/ArquivosFiscais.tsx';
import { EnviosDeEmail } from './features/envios/EnviosDeEmail.tsx';
import { Pendencias } from './features/pendencias/Pendencias.tsx';
import { PortalDoContador } from './features/portal/PortalDoContador.tsx';
import { Usuarios } from './features/usuarios/Usuarios.tsx';

/**
 * Rotas do sistema. Os caminhos espelham os itens de `app/navegacao.ts`: é de
 * lá que a barra lateral se monta, então um item novo precisa de uma rota com
 * o mesmo caminho.
 *
 * `/login` e `/p/:token` são as rotas públicas. Tudo o mais fica dentro de
 * `RotaProtegida`, que exige sessão; as que valem só para alguns papéis
 * declaram quais em `papeis`, do mesmo jeito que o item da barra lateral.
 * Isso é para a interface não oferecer o que não funciona — quem recusa de
 * verdade é a rota da API.
 *
 * `/p/:token` é o link que vai no e-mail do contador, e fica de fora do
 * `Layout` de propósito: quem abre não tem conta aqui, e uma barra lateral com
 * Clientes, Contabilidades e Usuários ofereceria portas que só respondem 401.
 */
export function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/p/:token" element={<PortalDoContador />} />

      <Route element={<RotaProtegida />}>
        <Route element={<Layout />}>
          <Route index element={<Navigate to="/clientes" replace />} />
          <Route path="clientes" element={<Clientes />} />
          <Route path="arquivos-fiscais" element={<ArquivosFiscais />} />
          <Route path="pendencias" element={<Pendencias />} />

          <Route element={<RotaProtegida papeis={['administrador', 'usuario']} />}>
            <Route path="contabilidades" element={<Contabilidades />} />
          </Route>

          {/* As instalações do agente moram dentro da linha do cliente, em
              /clientes: a pergunta que se faz sobre uma máquina é sempre
              sobre o cliente dela. O caminho antigo continua levando lá. */}
          <Route path="clients" element={<Navigate to="/clientes" replace />} />

          {/* O log de e-mails nasceu como "fechamentos", quando a tela era o
              rastro do envio automático. Hoje ela mostra todos os envios do
              sistema, e o caminho antigo continua levando lá. */}
          <Route path="fechamentos" element={<Navigate to="/envios-de-email" replace />} />

          {/* O log de e-mails é leitura, e a rota da API só exige sessão:
              quem atende o telefone precisa poder responder "saiu?" sem
              depender de um administrador. Revogar link, que é a única ação
              da tela, continua sendo de administrador — no servidor. */}
          <Route path="envios-de-email" element={<EnviosDeEmail />} />

          <Route element={<RotaProtegida papeis={['administrador']} />}>
            <Route path="usuarios" element={<Usuarios />} />
          </Route>

          <Route path="*" element={<Navigate to="/clientes" replace />} />
        </Route>
      </Route>
    </Routes>
  );
}
